<template>
    <vx-modal v-model:visible="visible" padding="standard" size="md">
        <template v-slot:header>Edit Contact</template>

        <div>
            <div class="flex flex-col gap-4">
                <vx-alert v-if="error" color="danger" :closeable="false">{{ error }}</vx-alert>
                <div>
                    <vx-label size="lg">First Name</vx-label>
                    <vx-input v-model="firstName" size="lg" />
                </div>
                <div>
                    <vx-label size="lg">Last Name</vx-label>
                    <vx-input v-model="lastName" size="lg" />
                </div>
            </div>
        </div>
        <template v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <vx-button
                    @click="
                        error = '';
                        visible = false;
                    "
                    color="muted"
                    size="lg"
                    type="button"
                    :disabled="saving"
                >
                    Cancel
                </vx-button>
                <vx-button
                    @click="submit"
                    type="button"
                    color="primary"
                    size="lg"
                    class="grow"
                    :loading="saving"
                    data-test="submit"
                >
                    Save
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>
<script setup>
import { VxModal, VxAlert, VxButton, VxInput, VxLabel } from '@voxie/frontend-components';
import { ref, watch } from 'vue';
import { useContactDetails } from '~/components/contacts/contact/useContactDetails';
import { useFormRequestHandler } from '~/composables/useFormRequestHandler';
import { catchRequestError } from '~/utils/request';

const visible = defineModel({
    default: false,
});

const { catchError } = useFormRequestHandler();
const { contact, save } = useContactDetails();

const saving = ref(false);
const error = ref('');
const firstName = ref('');
const lastName = ref('');

const submit = async () => {
    if (saving.value) {
        return;
    }

    saving.value = true;

    const originalFirstName = contact.value.first_name;
    const originalLastName = contact.value.last_name;

    try {
        contact.value.first_name = firstName.value;
        contact.value.last_name = lastName.value;

        await save();

        visible.value = false;
    } catch (e) {
        catchError(e);
        error.value = catchRequestError(e);
        contact.value.first_name = originalFirstName;
        contact.value.last_name = originalLastName;
    } finally {
        saving.value = false;
    }
};

watch(
    () => visible.value,
    async () => {
        firstName.value = contact.value.first_name;
        lastName.value = contact.value.last_name;
    },
    {
        immediate: true,
    }
);
</script>
